import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { motion, AnimatePresence } from 'framer-motion';
import React from 'react';
import Svg from '../_primitives/svg/svg.esm.js';

var _excluded = ["isIndeterminate", "isChecked"];
var MotionSvg = motion(Svg);
var styleOverridesCheckIcon = {
  fill: 'none',
  strokeWidth: 2,
  stroke: 'currentColor',
  strokeDasharray: 16
};
var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/React.createElement(MotionSvg, _extends({
    width: "1.2em",
    viewBox: "0 0 12 10",
    variants: {
      unchecked: {
        opacity: 0,
        strokeDashoffset: 16
      },
      checked: {
        opacity: 1,
        strokeDashoffset: 0,
        transition: {
          duration: 0.2
        }
      }
    },
    style: styleOverridesCheckIcon
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "1.5 6 4.5 9 10.5 1"
  }));
};
var styleOverridesIndeterminateIcon = {
  stroke: 'currentColor',
  strokeWidth: 4
};
var variantsOverrides = {
  unchecked: {
    scaleX: 0.65,
    opacity: 0
  },
  checked: {
    scaleX: 1,
    opacity: 1,
    transition: {
      scaleX: {
        duration: 0
      },
      opacity: {
        duration: 0.02
      }
    }
  }
};
var IndeterminateIcon = function IndeterminateIcon(props) {
  return /*#__PURE__*/React.createElement(MotionSvg, _extends({
    width: "1.2em",
    viewBox: "0 0 24 24",
    variants: variantsOverrides,
    style: styleOverridesIndeterminateIcon
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: "21",
    x2: "3",
    y1: "12",
    y2: "12"
  }));
};
var styleOverridesCheckboxTransition = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
};
var checkboxVariants = {
  unchecked: {
    scale: 0.5
  },
  checked: {
    scale: 1
  }
};

//https://github.com/framer/motion/issues/1509
var CheckboxTransition = function CheckboxTransition(_ref) {
  var open = _ref.open,
    children = _ref.children;
  var NewAnimatePresence = AnimatePresence;
  return /*#__PURE__*/React.createElement(NewAnimatePresence, {
    initial: false
  }, open && /*#__PURE__*/React.createElement(motion.div, {
    variants: checkboxVariants,
    initial: "unchecked",
    animate: "checked",
    exit: "unchecked",
    style: styleOverridesCheckboxTransition
  }, children));
};
/**
 * CheckboxIcon is used to visually indicate the checked or indeterminate
 * state of a checkbox.
 *
 * @todo allow users pass their own icon svgs
 */
var CheckboxIcon = function CheckboxIcon(props) {
  var isIndeterminate = props.isIndeterminate,
    isChecked = props.isChecked,
    rest = _objectWithoutProperties(props, _excluded);
  var IconEl = isIndeterminate ? IndeterminateIcon : CheckIcon;
  return /*#__PURE__*/React.createElement(CheckboxTransition, {
    open: isChecked || isIndeterminate
  }, /*#__PURE__*/React.createElement(IconEl, rest));
};

export default CheckboxIcon;
//# sourceMappingURL=checkbox-icon.esm.js.map
